import { RELATION_OWNED_BY } from '@backstage/catalog-model';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import useAsync from 'react-use/esm/useAsync';
import { EntityPicker } from '../EntityPicker/EntityPicker.esm.js';
export { OwnedEntityPickerSchema } from './schema.esm.js';

const OwnedEntityPicker = (props) => {
  const {
    schema: { title = "Entity", description = "An entity from the catalog" },
    uiSchema,
    required
  } = props;
  const identityApi = useApi(identityApiRef);
  const { loading, value: identityRefs } = useAsync(async () => {
    const identity = await identityApi.getBackstageIdentity();
    return identity.ownershipEntityRefs;
  });
  if (loading)
    return /* @__PURE__ */ React.createElement(
      Autocomplete,
      {
        loading,
        renderInput: (params) => /* @__PURE__ */ React.createElement(
          TextField,
          {
            ...params,
            label: title,
            margin: "dense",
            helperText: description,
            FormHelperTextProps: { margin: "dense", style: { marginLeft: 0 } },
            variant: "outlined",
            required,
            InputProps: params.InputProps
          }
        ),
        options: []
      }
    );
  const entityPickerUISchema = buildEntityPickerUISchema(
    uiSchema,
    identityRefs
  );
  return /* @__PURE__ */ React.createElement(EntityPicker, { ...props, uiSchema: entityPickerUISchema });
};
function buildEntityPickerUISchema(uiSchema, identityRefs) {
  const uiOptions = uiSchema?.["ui:options"] || {};
  const allowedKinds = uiOptions.allowedKinds;
  const catalogFilter = {
    ...uiOptions.catalogFilter,
    ...allowedKinds ? {
      kind: allowedKinds,
      [`relations.${RELATION_OWNED_BY}`]: identityRefs || []
    } : {
      [`relations.${RELATION_OWNED_BY}`]: identityRefs || []
    }
  };
  return {
    "ui:options": {
      catalogFilter
    }
  };
}

export { OwnedEntityPicker };
//# sourceMappingURL=OwnedEntityPicker.esm.js.map
